import { render, staticRenderFns } from "./payment_location_list.vue?vue&type=template&id=4582d5c2&scoped=true&"
import script from "./payment_location_list.vue?vue&type=script&lang=js&"
export * from "./payment_location_list.vue?vue&type=script&lang=js&"
import style0 from "./payment_location_list.vue?vue&type=style&index=0&id=4582d5c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4582d5c2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4582d5c2')) {
      api.createRecord('4582d5c2', component.options)
    } else {
      api.reload('4582d5c2', component.options)
    }
    module.hot.accept("./payment_location_list.vue?vue&type=template&id=4582d5c2&scoped=true&", function () {
      api.rerender('4582d5c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/catalog/payments/item/pay_tabs/payment_location_list.vue"
export default component.exports